<p-messages
  class="m-messages"
  [value]="messages"
  [closable]="closable"
  [escape]="escape"
  (valueChange)="handleClose($event)"></p-messages>
